<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/yygk/home">医院概况</router-link> >
      {{ current.title }}
    </div>
    <div class="container-width">
      <ARTICLE
        :current="current"
        :before="before"
        :after="after"
        :showBeforeAfter="showBeforeAfter"
        :showorigin="showorigin"
      ></ARTICLE>
    </div>
    <!-- 滚动数据 -->
    <SCROLLViEW :Data="yygkData"></SCROLLViEW>
  </div>
</template>
<script>
import service from "../../service/yygk";
import BANNER from "@/components/banner/yygk";
import SCROLLViEW from "@/components/yygk/scrollview";
export default {
  name: "YYGKARTICLE",
  data() {
    return {
      navigationData: [
        {
          name: "医院概况",
          path: "/yygk/home",
        },
      ],
      currentPath: "/yygk/home",
      current: {},
      // 上一篇
      before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showBeforeAfter: false, //是否显示上一篇 下一篇
      showorigin: false, //是否显示来源 发布时间 点击次数
      yygkData: [],
      pageIndex: 1,
      pageSize: 1000,
      list: [],
      topTitle: "",
      topDescription: "",
    };
  },
  components: {
    BANNER,
    SCROLLViEW,
  },
  computed: {},
  created() {
    let id = this.$route.query.id;
    this.init(id);
  },
  beforeMount() {},
  methods: {
    startLoading() {
      //使用Element loading-start 方法
      this.Loading = this.$loading({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector("#app"), //loadin覆盖的dom元素节点
        body: true,
      });
    },
    init(id) {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };

      service.getHosOverviewlist(parmes, (res) => {
        if (res.content.length) {
          this.topTitle = res.content[0].title;
          this.topDescription = res.content[0].description || "";
          res.content.map((item) => {
            if (item.introduction) {
              item.introduction =
                item.introduction.length > 40
                  ? item.introduction.substring(0, 40) + "..."
                  : item.introduction;
            }
          });
        }
        this.yygkData = res.content;
        // this.$nextTick(() => {
        //   this.swiperiImg();
        // });
      });
      service.getHosOverviewInfo({ id: id }, (res) => {
        res.description = res.description.replace(
          /\<img/gi,
          '<img style="max-width:90%;height:auto"'
        );
        this.current = { ...res };
      });
    },

    // swiperiImg() {
    //   var wW = $(window).width();
    //   var swipericon;
    //   if (wW > 768) {
    //     swipericon = new Swiper(".honor_swiper", {
    //       slidesPerView: "4",
    //       mode: "horizontal",
    //       loop: true,
    //       navigation: {
    //         nextEl: ".fr",
    //         prevEl: ".fl",
    //       },
    //     });
    //   } else {
    //     swipericon = new Swiper(".honor_swiper", {
    //       slidesPerView: "2",
    //       mode: "horizontal",
    //     });
    //   }
    // },
  },
  mounted() {},
  watch: {},
};
</script>


<style scoped lang="scss">


</style>
